import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconParcel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconParcel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '39d89cda41a6e06abc963e0e897cc53e96c56655', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c4af3aafabae7246589f66e4838aebacc547e1ec', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9c3c1ac2aa3ec60d6532e245d1e22335c0b21216', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.545 6.168 11.3 3.061a.75.75 0 0 0-.59 0L3.455 6.168a.75.75 0 0 0-.455.69v8.285c0 .3.179.572.455.69l7.25 3.107q.016-.002.033.006a.66.66 0 0 0 .524 0q.017.001.033-.006l7.25-3.107a.75.75 0 0 0 .455-.69V6.857a.75.75 0 0 0-.455-.689M11 4.566l5.346 2.291-.333.143-1.513.65-5.348-2.292zm-.75 12.547L4.5 14.65V7.995l5.451 2.336.3.128zM11 9.15 5.987 7l-.333-.143L7.5 6.065l5.347 2.292zm6.5 5.5-5.75 2.464V10.46l.3-.128 5.45-2.336z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-parcel", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-parcel"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-parcel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconParcel$1);
            }
            break;
    } });
}

const CosmosIconParcel = CosmosIconParcel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconParcel, defineCustomElement };
